<template>
  <Pull :onPull="pull" ref="pull">
  <div class="main-content">
    <div class="head-navigate">
      <a-icon
        type="left"
        :style="{ fontSize: '20px', color: '#333' }"
        @click="backPage"
      />
      <span>客户列表</span>
    </div>
    <!-- 搜索功能部分 -->
    <div class="search-content">
      <a-input placeholder="客户姓名" v-model="inputValue" @change="inputSearch">
        <a-icon slot="prefix" type="search" />
      </a-input>
    </div>
    <!-- 状态筛选部分 -->
    <div class="status-select">
      <div @click="statusShow=true">
        <span>状态</span>
        <a-icon type="down" style="" />
      </div>
      <div @click="rankShow=true">
        <span>排序</span>
        <a-icon type="down" />
      </div>
    </div>
    <!-- 列表部分 -->
    <div class="list-content" v-if="resdata.length > 0">
      <div class="content-part" @click="navigatePage(item)" v-for="(item,index) in resdata" :key="index">
        <img src="../assets/1.webp" mode="" />
        <div>
          <div>
            <span>{{item.customerName}}</span>
            <span :style="{ color: item.statusName=='已签约'?'#fff':'#1584FF' }">{{item.statusName?item.statusName:'未签约'}}</span>
          </div>
          <span>{{item.customerPhone}}</span>
          <span>客户经理：{{item.customManagerName}}</span>
        </div>
      </div>
    </div>
    <div class="no-data" v-else>
      <img src="../assets/propertyImg/no-data.png" alt="" />
      <span>暂无房屋数据列表</span>
    </div>
    <!-- <div class="loadMore" v-if="isData" @click="gainMore">
      加载更多
    </div> -->
    <!-- <div class="noMore" v-if="!isData">
      没有更多了。。。
    </div> -->
    <!-- 状态选择 -->
		<van-action-sheet v-model="statusShow">
			<van-picker
			title="状态"
			show-toolbar
			value-key="statusName"
			:columns="statusActions"
			@confirm="statusSelect"
			@cancel="statusShow=false"
			/>
		</van-action-sheet>
    <!-- 排序选择 -->
		<van-action-sheet v-model="rankShow">
			<van-picker
			title="排序"
			show-toolbar
			value-key="name"
			:columns="rankActions"
			@confirm="rankSelect"
			@cancel="rankShow=false"
			/>
		</van-action-sheet>
  </div>
  </Pull>
</template>
<script>
import { clientList, followStatus } from "@/axios/property";
import Pull from '../commonComponents/PullRefresh'
export default {
  components: {
    Pull
  },
  data() {
    return {
      resdata: [], // 客户列表数据
      statusShow: false, // 状态选择框
      statusActions: [],// 状态种类
      rankShow: false, // 排序选择框
      rankActions: [ // 排序种类
				{ name: '全部', value: null },
				{ name: '正序', value: 0 },
				{ name: '倒序', value: 1 }
			],
      statusArr: [], // 状态选择
      rankValue: null, // 排序值,
      inputValue: '', // 输入框的值
      companyId: '', // 公司ID
      isData: true,
      currentPage: 1,
      currentPageSize: 30
    };
  },
  created(){
    console.log(this.$store.state.initialData)
    this.companyId = this.$store.state.initialData.companyId
    this.getData()
    this.getStatusList()
  },
  methods: {
    pull(num) { // 上拉刷新
        console.log('pull回调List');
        this.gainMore()
        // setTimeout(() => {
        //   this.num = num;
        //   if (this.history_list.length >= this.pk_list_data.others_family_list.length) {
        //     console.log('完了');
        //     this.$refs.pull.$emit('loadOver') // 加载完毕
        //   } else {
        //     console.log(666)
        //     this.$refs.pull.$emit('loadEnd') // 加载完毕
        //   }

        // }, 2000)
      },
    inputSearch(){ // 搜索框输入值搜索
      this.resdata = []
      this.currentPage = 1
      this.getData()
    },
    gainMore(){ // 加载更多数据列表
      this.currentPage += 1
      this.getData()
    },
    getData() { // 获取列表数据
      let that = this
      let data = {
        companyId: this.companyId,
        followStatuses: this.statusArr,
        isAscSort: this.rankValue,
        customerName: this.inputValue,
        currentPage: this.currentPage,
        currentPageSize: this.currentPageSize
      };
      if(data.isAscSort==null){
        delete data.isAscSort
      }
      clientList(data).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          let responseData = res.data.data.records;
          if (responseData.length == 0) {
            that.$refs.pull.$emit('loadOver') // 加载完毕，无数据了
            that.isData = false;
          } else {
            that.$refs.pull.$emit('loadEnd') // 加载完毕，可能还有下一波数据
            for (let i = 0; i < responseData.length; i++) {
              that.resdata.push(responseData[i]);
            }
            that.isData = true;
          }
        }
      });
    },
    getStatusList(){ // 获取跟进状态列表
      let that = this
      let data = {
        companyId: this.companyId
      };
      followStatus(data).then((res) => {
        console.log(res);
        if(res.data.code==0){
          that.statusActions = res.data.data
        }
      });
    },
    navigatePage(item) {
      this.$router.push({
					name: 'ClientDetail',
					params: {
						obj: item
					}
				})
    },
    statusSelect(value) { // 更改状态
      console.log(value)
      this.statusArr = [value.statusId]
      this.resdata = []
			this.getData()
      this.statusShow = false
		},
    rankSelect(value) { // 更改排序
      console.log(value)
      this.rankValue = value.value
      this.resdata = []
			this.getData()
      this.rankShow = false
		},
    backPage() {
      // 回退到首页
      this.$router.push('/property-index')
    },
  },
};
</script>
<style scoped>
.main-content {
  background-color: #f9f9f9;
  margin-bottom: 0.3rem;
}
.head-navigate {
  display: flex;
  align-items: center;
  background-color: white;
  padding: 0.2rem 0.3rem;
}
.head-navigate span {
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #333333;
  margin: auto;
}
/* 搜索功能部分 */
.search-content {
  margin: 0 auto;
  display: flex;
  align-items: center;
  background-color: white;
  padding: 0.4rem;
}

.search-content /deep/.ant-input {
  background-color: #f7f8fa;
}
/* 状态筛选部分 */
.status-select {
  display: flex;
  align-items: center;
  background-color: white;
  height: 1rem;
}
.status-select > div {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #939496;
}
.status-select > div:nth-child(1) {
  margin-left: 0.5rem;
  margin-right: auto;
}

.status-select /deep/.anticon {
  margin-top: 0.05rem;
}
.status-select > div:nth-child(2) {
  margin-right: 0.5rem;
}
/* 列表内容部分 */
.list-content {
  margin-top: 0.5rem;
  background-color: white;
  padding: 0.5rem 0;
}
.list-content .content-part {
  width: 90%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding-bottom: 0.5rem;
  margin-bottom: 0.5rem;
  border-bottom: 1px solid #f3f3f3;
}
.content-part img {
  width: 1.5rem;
  height: 1.5rem;
}
.content-part > div {
  display: flex;
  flex-direction: column;
  margin-left: 0.5rem;
  width: 100%;
}
.content-part > div > div {
  margin-bottom: 0.07rem;
  display: flex;
}
.content-part > div > div span:nth-child(1) {
  margin-right: auto;
  font-size: 0.45rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #333333;
}
.content-part > div > div span:nth-child(2) {
  width: 1.8rem;
  height: 22px;
  line-height: 22px;
  border-radius: 2px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #808080;
  text-align: center;
}
.content-part > div > span {
  margin-bottom: 0.1rem;
  font-size: 0.35rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
.no-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 0.3rem;
}
.no-data img {
  width: 5rem;
  height: 5rem;
  margin-bottom: 0.5rem;
}
.no-data span {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  font-size: 28rpx !important;
}
/* 加载更多按钮样式 */
.loadMore {
  width: 50%;
  border-radius: 10px;
  margin: 0 auto;
  background-color: #1584ff;
  color: white;
  text-align: center;
  padding: 0.2rem 0;
  margin-top: 0.5rem;
}
.noMore {
  width: 50%;
  margin: 0 auto;
  color: #ccc;
  text-align: center;
  padding: 0.03rem 0;
  margin-top: 0.5rem;
}
</style>
